import React, { useEffect } from 'react';
import { Link, Switch, Route, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { FaEye } from 'react-icons/fa';
import { BasicContent } from '../components';
import { Loading, Paginate } from '~/components';
import { loadMeusEmpreendimentos } from '~/store/modules/pessoa_juridica/action';
import Show from '../Show';
// import Create from '../Create';

const List = () => {
  let location = useLocation();
  let modal = location.state && location.state.modal;
  const dispatch = useDispatch();
  const { pessoa_juridicas, meta } = useSelector(
    ({ PessoaJuridicaReducer }) => PessoaJuridicaReducer
  );

  useEffect(() => {
    dispatch(loadMeusEmpreendimentos());
  }, [dispatch]);


  const breadcrumb = {
    label: 'Lista',
    to: '/empreendimentos/meus_empreendimentos',
    active: false,
  };

  return (
    <>
      {modal && (
        <Switch>
          <Route
            children={<Show />}
            exact
            path="/empreendimentos/meus_empreendimentos/:user_id/detalhe"
          />
          {/* <Route
            children={<Create />}
            path="/empreendimentos/meus_empreendimentos/create"
          /> */}
        </Switch>
      )}
      <BasicContent breadcrumb={breadcrumb}>
        <div className="card">
          <div className="card-header">
            <h2 className="card-title">Lista</h2>
            <div className="card-tools">
              {/* <Link
                className="btn btn-success"
                to={{
                  pathname: '/empreendimentos/meus_empreendimentos/create',
                  state: { modal: true },
                }}
              >
                <i className="fa fa-plus" /> Novo
              </Link> */}
            </div>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-sm table-bordered table-hover table-striped">
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Razão Social</th>
                    <th>Nome Fantasia</th>
                    <th>CNPJ</th>
                    <th>Email</th>
                    <th className="text-right">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {pessoa_juridicas.data &&
                    pessoa_juridicas.data.map((pessoa_juridica, index) => (
                      <tr key={index}>
                        <td>{pessoa_juridica.id}</td>
                        <td>{pessoa_juridica.nome}</td>
                        <td>{pessoa_juridica.nome_fantasia}</td>
                        <td>{pessoa_juridica.cnpj}</td>
                        <td>{pessoa_juridica.email}</td>
                        <td>
                          <div className="btn-group float-right">
                            <Link
                              className="btn btn-info"
                              to={{
                                pathname: `/empreendimentos/meus_empreendimentos/${pessoa_juridica.user_id}/detalhe`,
                                state: { modal: true },
                              }}
                            >
                              <FaEye /> Detalhes
                            </Link>
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
              {!pessoa_juridicas && <Loading />}
            </div>
          </div>
          <div className="card-footer clearfix">
            <Paginate
              load={loadMeusEmpreendimentos}
              meta={meta}
            />
          </div>
        </div>
      </BasicContent>
    </>
  );
};

export default List;
